import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import TrainingPrograms from '../components/TrainingPrograms';

const ProgramsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔹 HIGH-CONVERSION SEO DATA
  const seoTitle = "Top IT Training Courses in Indore | Cybersecurity, AI & Cloud | Ciqura Labs";
  const seoDescription = "Master high-demand tech skills at Ciqura Labs Indore. Expert-led certification courses in Cybersecurity, AIML, Full Stack, and GRC with guaranteed internship at Ciqur24 Bengaluru.";
  const pageUrl = "https://ciquralabs.ciqur24.com/programs";

  // 🔹 200-WORD TRENDING KEYWORD BLOCK FOR 2026
  const trendingKeywords = "Cybersecurity training in Indore, Ethical Hacking course Indore, Ciqura Labs, Best Cyber Security Institute in Indore, Vijay Nagar IT training, Cyber Security for beginners, Ethical hacking certification Indore, Infosec training Indore, Cybersecurity placement Indore, VAPT certification Indore, SOC Analyst course Indore, Cyber Security classes in Vijay Nagar, Network Security training Indore, Information security courses MP, Cyber security internship 2026, Hands-on hacking labs, Cyber career roadmap, AI training Indore, Machine Learning course Indore, AIML training Vijay Nagar, Generative AI course, Prompt Engineering training, AI for Cybersecurity training, Deep Learning classes Indore, Python for AI/ML, AI Security Engineer course, MLOps training, Data Science and AI Indore, Artificial Intelligence certification, Best AI institute Indore, AI-powered threat detection training, GRC training online, Cloud security governance, Microsoft 365 Admin course, Cisco Networking Indore, Full Stack Web Development Indore, Web dev classes Indore, Python programming Indore, Cloud SOC Analyst, API Security Pentesting, DevSecOps certification, Red Teaming training, Zero Trust Architecture course, Bug Bounty hunting, Post-Quantum Cryptography, AI Forensics, Cybersecurity Bengaluru internship, IT training near me, Ethical hacking classes Vijay Nagar, Cyber Security career Indore, Hacking certification online, Industrial Cybersecurity training, Office 113 Shagun Arcade Indore training, Ciqura Labs Indore courses, IT Park Indore training, Best IT coaching Indore, Placement oriented courses Indore";

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
      
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={trendingKeywords} />
        <link rel="canonical" href={pageUrl} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content="https://res.cloudinary.com/dlz8euavh/image/upload/v1769179291/3_zbjtyy.png" />

        {/* 🔹 ENHANCED SCHEMA FOR SEARCH DOMINANCE */}
        <script type="application/ld+json">
          {JSON.stringify([
            {
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": "Ciqura Labs Professional Certifications",
              "description": "Industry-aligned IT and Cybersecurity training programs in Vijay Nagar, Indore.",
              "url": pageUrl,
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Cybersecurity & Ethical Hacking",
                  "url": `${pageUrl}/cybersecurity`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "AI & Machine Learning (AIML)",
                  "url": `${pageUrl}/aiml`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Governance, Risk & Compliance (GRC)",
                  "url": `${pageUrl}/grc`
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "name": "Full Stack Web Development",
                  "url": `${pageUrl}/full-stack-development`
                },
                {
                  "@type": "ListItem",
                  "position": 5,
                  "name": "Professional Python Developer",
                  "url": `${pageUrl}/python-developer`
                }
              ]
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://ciquralabs.ciqur24.com" },
                { "@type": "ListItem", "position": 2, "name": "Programs", "item": pageUrl }
              ]
            }
          ])}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section style={{ padding: '80px 7.6923%', textAlign: 'center', background: 'radial-gradient(circle at center, rgba(0,255,209,0.08) 0%, transparent 70%)' }}>
         <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <h1 className="display-huge" style={{ marginBottom: '24px', lineHeight: 1.1 }}>
              Professional <span style={{ color: 'var(--brand-primary)' }}>IT & Security</span> Training
            </h1>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '850px', margin: '0 auto', fontSize: '20px', lineHeight: 1.6 }}>
              Move beyond theory. Get trained at <strong style={{ color: '#fff' }}>Ciqura Labs Indore</strong>, the training division of <strong style={{ color: 'var(--brand-primary)' }}>Ciqur24 Bengaluru</strong>. 
              Our programs are designed for 2026's job market, featuring Generative AI security, advanced VAPT, and enterprise Cloud workflows.
            </p>
         </div>
      </section>

      {/* Main Programs Component */}
      <div style={{ paddingBottom: '100px' }}>
        <TrainingPrograms />
      </div>

      {/* Local SEO Footer Hint Section */}
      <section style={{ padding: '60px 7.6923%', textAlign: 'center', background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-subtle)' }}>
        <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
          Visit our Indore Lab: 113, First Floor, Shagun Arcade, Vijay Nagar, Indore <br />
        </p>
      </section>
    </div>
  );
};

export default ProgramsPage;